import {
  CalendarIcon,
  DeviceMobileIcon,
  GlobeIcon,
  InfoIcon,
  KebabHorizontalIcon,
  LinkIcon,
  LocationIcon,
  MailIcon,
  NoteIcon,
  PencilIcon,
  PersonIcon,
  PlusIcon,
  ShareAndroidIcon,
  SyncIcon,
  TasklistIcon,
  TrashIcon,
  WorkflowIcon,
} from "@primer/octicons-react";
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useCommonContext } from "../../contexts/common";
import { useCommonSelectedHook } from "../../hooks/useCommonSelectedHook";
import { chienDichApi } from "../../api/chienDichApi";
import { NotifyHelper } from "../../helpers/toast";
import { phuHuynhApi } from "../../api/phuHuynhApi";
import { IDmChienDichView } from "../../models/response/chien-dich/IDmChienDichView ";
import { IPhuHuynhItemResponse } from "../../models/response/hoc-sinh/IPhuHuynhItemReponse";
import DataTable from "../../components/ui/data-table";
import {
  ActionList,
  ActionMenu,
  Box,
  IconButton,
  Label,
  Link,
  useConfirm,
} from "@primer/react";
import TextTranslated from "../../components/text";
import moment from "moment";
import { ComboboxTruong } from "../../components/combobox-truong";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../state/reducers";
import Button from "../../components/ui/button";
import { IPhuHuynhSelectRequest } from "../../models/request/phu-huynh/IPhuHuynhSelectRequest";
import { actions } from "../../state/actions/actionsWrapper";
import { ePageBaseStatus } from "../../models/ePageBaseStatus";
import PhuHuynhStatusSummary from "../../components/phu-huynh-status-summary/PhuHuynhStatusSummary";
import UserAvatar from "../../components/user-avatar";
import PhuHuynhInsertModal from "./insert-modal/PhuHuynhInsertModal";
import PhuHuynhProfile from "../phu-huynh-profile";
import ComboboxTrangThaiPhuHuynh from "../../components/combobox-trangthai-phuhuynh";
import SelectBoxTrangThaiHocSinhMultiple from "../../components/selectbox-trangthai-hocsinh-multiple";
import Text from "../../components/ui/text";
import GanNguoiPhuTrachDetailModal from "./GanNguoiPhuTrachDetailModal";

const PhuHuynhPage = ({
  onValueChanged,
}: {
  onValueChanged?: (values: { dm_trangthaiphuhuynh_ids: string }) => void;
}) => {
  const { status, PhuHuynhs } = useSelector(
    (state: RootState) => state.crmPhuHuynh
  );
  const { nam_hoc, dm_coso_id } = useCommonSelectedHook();
  const { translate } = useCommonContext();
  const confirm = useConfirm();
  const dispatch = useDispatch();

  const { dm_truong_selected_id } = useSelector((x: RootState) => x.common);
  const [dm_trangthaiphuhuynh_id, setDmTrangThaiPhuHuynhId] =
    useState<number>(0);
  const [chienDichSelectedId, setChienDichSelectedId] = useState(0);
  const [selectedId, setSelectedId] = useState(0);
  const [phuHuynhEditing, setPhuHuynhEditing] = useState({ id: 0 });
  const [filterStatusId, setFilterStatusId] = useState(0);
  const [ts_phuhuynhs, setTsPhuHuynhs] = useState<IPhuHuynhItemResponse[]>([]);
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowPHModal, setIsShowPHModal] = useState(false);
  const [danhSachPhuHuynhSelectedId, setDanhSachPhuHuynhSelectedId] = useState<
    number[]
  >([]);
  const [isShowModalGanNguoiPhuTrach, setIsShowModalGanNguoiPhuTrach] = useState(false);

  // const [dmChiendichs, setDmChiendichs] = useState<IDmChienDichView[]>([]);
  // const [chienDichSelectedId, setChienDichSelectedId] = useState(0);
  // const [filterStatusId, setFilterStatusId] = useState(0);
  // const [userTuVanVienFilter, setUserTuVanVienFilter] = useState("");
  // const [phuHuynhEditing, setPhuHuynhEditing] = useState({ id: 0 });
  useEffect(() => {
    setTsPhuHuynhs(PhuHuynhs);
  }, [PhuHuynhs]);
  // Function to load data
  const handleReload = useCallback(() => {
    const payload: IPhuHuynhSelectRequest = {
      dm_coso_id: dm_coso_id,
      ts_phuhuynh_adm_status_id: dm_trangthaiphuhuynh_id,
      dm_chiendich_id: chienDichSelectedId,
    };
    dispatch(actions.crmPhuHuynh.LOAD_START(payload));
  }, [dm_trangthaiphuhuynh_id, dm_coso_id, chienDichSelectedId, dispatch]);

  useEffect(() => {
    if (
      status === ePageBaseStatus.is_not_initialization ||
      status === ePageBaseStatus.is_need_reload
    ) {
      handleReload();
    }
  }, [status, handleReload]);

  const dataSource = useMemo(() => {
    return ts_phuhuynhs.filter(
      (x) =>
        x.ts_phuhuynh_adm_status_id == filterStatusId || filterStatusId == 0
    );
  }, [filterStatusId, ts_phuhuynhs]);

  // const tuVanViens = useMemo(() => {
  //   const user_tu_van_full_names = phuHuynhs.map((x) => x.user_tu_van_full_name ? x.user_tu_van_full_name : '--Chưa gán--');
  //   const distinctTuVanVienNames = [...new Set(user_tu_van_full_names)];
  //   return distinctTuVanVienNames.map((x) => ({ id: x, name: x }));
  // }, [phuHuynhs]);
  // const handleEditClick = (data: any) => {
  //   setPhuHuynhEditing(data);
  //   setSelectedId(data);
  //   alert(selectedId)
  //   setIsShowModal(true);
  // };

  const handeDelete = async (id: number) => {
    if (
      await confirm({
        content: `${translate("Base.Label.ConfirmDelete")}`,
        title: `${translate("Base.Label.Warning")}`,
        cancelButtonContent: `${translate("Base.Label.No")}`,
        confirmButtonContent: `${translate("Base.Label.Yes")}`,
        confirmButtonType: "danger",
      })
    ) {
      const res = await phuHuynhApi.delete(id);
      if (res.is_success) {
        NotifyHelper.Success("Success");
        handleReload();
      } else {
        NotifyHelper.Error(res.message ?? "");
      }
    }
  };
  const onSelectionChanged = (selectedRowKeys: number[]) => {
    setDanhSachPhuHuynhSelectedId(selectedRowKeys);
  };
  return (
    <Box
      sx={{
        p: 3,
        overflowX: "auto", // Bật thanh cuộn ngang
      }}
    >
      {/* <div
        className="col-md-12 p-0"
        style={{
          marginTop: 10,
        }}
      >
        <PhuHuynhStatusSummary
          onSelectionChanged={setFilterStatusId}
          ts_phuhuynhs={ts_phuhuynhs}
        />
      </div> */}
      <DataTable
        height={`${window.innerHeight - 230}px`}
        data={dataSource}
        title={translate("Phụ huynh")}
        subTitle={`${translate("Base.Label.TotalCount")}: ${dataSource.length}`}
        searchEnable
        paging={{ enable: true }}
        selection={{
          mode: "multiple",
          keyExpr: "id",
          selectedRowKeys: danhSachPhuHuynhSelectedId,
          onSelectionChanged(keys) {
            onSelectionChanged(keys);
          },
        }}
        actionComponent={
          <Box
            sx={{
              display: "flex",
            }}
          >
            {/* <ComboboxTruong
              value={dm_truong_selected_id}
              onValueChanged={(value) => {
                dispatch(
                  actions.common.changedValueHeaderComboboxTruong(value)
                );
              }}
            /> */}
            <ComboboxTrangThaiPhuHuynh
              value={filterStatusId}
              onValueChanged={setFilterStatusId}
              phuHuynhs={PhuHuynhs} 
              isCounting = {true}
            />

            <Button
              sx={{ mx: 1 }}
              text="Base.Label.AddNew"
              leadingVisual={PlusIcon}
              size="medium"
              variant="primary"
              onClick={() => {
                setSelectedId(0);
                setIsShowModal(true);
              }}
            />
            <ActionMenu>
                <ActionMenu.Button >
                  Thao tác
                </ActionMenu.Button>
                <ActionMenu.Overlay width="auto">
                  <ActionList showDividers>                   
                  <ActionList.Item
                     onSelect={() => {
                      if (danhSachPhuHuynhSelectedId.length > 0) {
                        setIsShowModalGanNguoiPhuTrach(true);
                      } else {
                        NotifyHelper.Warning("Vui lòng chọn phụ huynh");
                      }
                     }}
                    >
                      <ActionList.LeadingVisual>
                        <TasklistIcon />
                      </ActionList.LeadingVisual>
                      <Text
                        text={`Gán người phụ trách`}
                      />
                    </ActionList.Item>        
                  </ActionList>
                </ActionMenu.Overlay>
              </ActionMenu>

            <Button
              text="Base.Label.Refresh"
              leadingVisual={SyncIcon}
              size="medium"
              sx={{ ml: 1 }}
              onClick={() => {
                handleReload();
              }}
            />
          </Box>
        }
        columns={[
          {
            id: "cmd",
            width: "50px",
            align: "center",
            cellRender: (data: IPhuHuynhItemResponse) => {
              return (
                <ActionMenu>
                  <ActionMenu.Anchor>
                    <IconButton
                      icon={KebabHorizontalIcon}
                      variant="invisible"
                      aria-label="Open column options"
                    />
                  </ActionMenu.Anchor>

                  <ActionMenu.Overlay>
                    <ActionList>
                      <ActionList.Item
                        onClick={() => {
                          setSelectedId(data.id);
                          setIsShowModal(true);
                        }}
                      >
                        <ActionList.LeadingVisual>
                          <PencilIcon />
                        </ActionList.LeadingVisual>
                        <TextTranslated value="Base.Label.Edit" />
                      </ActionList.Item>
                      <ActionList.Divider />
                      <ActionList.Item
                        variant="danger"
                        onSelect={() => {
                          handeDelete(data.id);
                        }}
                      >
                        <ActionList.LeadingVisual>
                          <TrashIcon />
                        </ActionList.LeadingVisual>
                        <TextTranslated value="Base.Label.Delete" />
                      </ActionList.Item>
                    </ActionList>
                  </ActionMenu.Overlay>
                </ActionMenu>
              );
            },
          },
          {
            dataField: "ts_phuhuynh_adm_status_name",
            width: "100px",
            caption: translate("Trạng thái"),
            cellRender: (data: IPhuHuynhItemResponse) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <Label
                    style={{ marginLeft: "5px" }}
                    variant={
                      data.ts_phuhuynh_adm_status_name === "New Enrollment"
                        ? "accent"
                        : data.ts_phuhuynh_adm_status_name === "Re-Enrollment"
                        ? "success"
                        : data.ts_phuhuynh_adm_status_name === "Tiềm năng"
                        ? "sponsors"
                        : data.ts_phuhuynh_adm_status_name === "Thôi học"
                        ? "danger"
                        : "default"
                    }
                  >
                    {data.ts_phuhuynh_adm_status_name ?? "Chưa có"}
                  </Label>
                </Box>
              );
            },
          },
          {
            dataField: "ten_chien_dich",
            width: "100px",
            caption: translate("Chiến dịch"),
            cellRender: (data: IPhuHuynhItemResponse) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  {data.ten_chien_dich || ""}
                </Box>
              );
            },
          },

          {
            dataField: "avatar",
            width: "100px",
            caption: translate("Avatar"),
            cellRender: (data: IPhuHuynhItemResponse) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#10375C" }}>
                      <UserAvatar fullName={data.ho_ten} size="large" />
                    </div>
                  </div>
                </Box>
              );
            },
          },
          {
            dataField: "ho_ten",
            caption: translate("Họ tên"),
            cellRender: (data: IPhuHuynhItemResponse) => {
              const handleRowClick = () => {
                setSelectedId(data.id);
                setIsShowPHModal(true);
              };

              const handleCloseModal = () => {
                setIsShowPHModal(false);
              };

              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "start",
                    justifyContent: "center",
                    height: "100%",
                    cursor: "pointer",
                  }}
                  onClick={handleRowClick}
                >
                  <Link href="#" underline>
                    <span style={{ fontWeight: "500", marginLeft: "5px" }}>
                      {data.ho_ten}
                    </span>
                  </Link>

                  {/* <RowDetailModal
                    isOpen={isShowModal}
                    onClose={handleCloseModal}
                    rowData={data}
                  /> */}
                </Box>
              );
            },
          },
          {
            dataField: "gioi_tinh",
            caption: translate("Giới tính"),
            cellRender: (data: IPhuHuynhItemResponse) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                  }}
                >
                  {data.gioi_tinh || "..."}
                </Box>
              );
            },
          },
          {
            dataField: "thong_tin_phu_huynh",
            caption: translate("Thông tin chi tiết"),
            cellRender: (data: IPhuHuynhItemResponse) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div style={{ color: "#133E87" }}>
                        <DeviceMobileIcon size={14} />
                      </div>
                      <span style={{ marginLeft: "5px" }}>
                        {data.dien_thoai}
                      </span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div style={{ color: "#133E87" }}>
                        <MailIcon size={14} />
                      </div>{" "}
                      <span style={{ marginLeft: "5px" }}>
                        {data.email || "..."}
                      </span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div style={{ color: "#133E87" }}>
                        <LocationIcon size={14} />
                      </div>{" "}
                      <span style={{ marginLeft: "5px" }}>
                        {data.dia_chi_thuong_tru || "..."}
                      </span>
                    </div>
                  </Box>
                </Box>
              );
            },
          },
          {
            dataField: "thong_tin_cham_soc",
            caption: translate("Thông tin chăm sóc gần nhất"),
            cellRender: (data: IPhuHuynhItemResponse) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                    }}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div style={{ color: "#133E87" }}>
                        <CalendarIcon size={14} />
                      </div>
                      <span style={{ marginLeft: "5px" }}>
                        {data.ngay_cham_soc_gan_nhat
                          ? moment(data.ngay_cham_soc_gan_nhat).format(
                              "DD/MM/YYYY"
                            )
                          : "..."}
                      </span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div style={{ color: "#133E87" }}>
                        <NoteIcon size={14} />
                      </div>{" "}
                      <span style={{ marginLeft: "5px" }}>
                        {data.noi_dung_cham_soc_gan_nhat || "..."}
                      </span>
                    </div>
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <div style={{ color: "#133E87" }}>
                        <PersonIcon size={14} />
                      </div>{" "}
                      <span style={{ marginLeft: "5px" }}>
                        {data.nguoi_cham_soc_gan_nhat || "..."}
                      </span>
                    </div>
                  </Box>
                </Box>
              );
            },
          },
          {
            dataField: "nguoiphutrach_name",
            caption: translate("Người phụ trách"),
            cellRender: (data: IPhuHuynhItemResponse) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <PersonIcon size={14} />
                    </div>
                    <span style={{ marginLeft: "5px" }}>
                      {data.nguoiphutrach_name ?? "..."}
                    </span>
                  </div>
                </Box>
              );
            },
          },
          {
            dataField: "user_tu_van_full_name",
            caption: translate("Tư vấn viên"),
            cellRender: (data: IPhuHuynhItemResponse) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <PersonIcon size={14} />
                    </div>
                    <span style={{ marginLeft: "5px" }}>
                      {data.user_tu_van_full_name ?? "..."}
                    </span>
                  </div>
                </Box>
              );
            },
          },
          {
            dataField: "ngay_tao",
            caption: translate("Ngày tạo"),
            cellRender: (data: IPhuHuynhItemResponse) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div style={{ color: "#133E87" }}>
                      <CalendarIcon size={14} />
                    </div>
                    <span style={{ marginLeft: "5px" }}>
                      {data.ngay_tao
                        ? moment(data.ngay_tao).format("DD/MM/YYYY")
                        : ""}
                    </span>
                  </div>
                </Box>
              );
            },
          },
         
        ]}
      />
      {isShowModal && (
        <PhuHuynhInsertModal
          id={selectedId}
          onClose={() => {
            setIsShowModal(false);
          }}
          onSuccess={() => {
            handleReload();
            setIsShowModal(false);
          }}
        />
      )}
      {isShowPHModal && (
        <PhuHuynhProfile
          id={selectedId}
          onClose={() => {
            setIsShowPHModal(false);
          }}
          onSuccess={() => {
            handleReload();
            setIsShowPHModal(false);
          }}
        />
      )}
       {isShowModalGanNguoiPhuTrach && (
          <GanNguoiPhuTrachDetailModal
            selectedIds={danhSachPhuHuynhSelectedId}
            onClose={() => setIsShowModalGanNguoiPhuTrach(false)}
            onSuccess={() => {
              setIsShowModalGanNguoiPhuTrach(false);
              handleReload(); 
            }}
          />
        )}
    </Box>
  );
};

export default PhuHuynhPage;
